import { Tooltip, Typography } from '@material-ui/core';
import * as React from 'react';
import { AccessCheckExcludedRolePermissions } from './AccessCheckExcludedRolePermissions';
import { IAccessRelationData } from './AccessDomainModels';
import { IDictionary, IUserAccessDataRow } from './AccessUserAccessesService';
import { RequestControl } from '../Relations/RequestControl';
import { useTranslation } from 'react-i18next';

interface IProps {
	row: IAccessRelationData,
	rowsPerUsers: IDictionary<IUserAccessDataRow[]>,
	table: RequestControl,
}

export function RenderRoleCell(props: IProps) {
	const { t } = useTranslation();
	const row = props.row;
	if (!row.role) {
		return null;
	}
	var excluded = row.excluded;
	if (!excluded) {
		let currentUserAccesses: IUserAccessDataRow[] = null;
		if (row.employee) {
			currentUserAccesses = props.rowsPerUsers[row.employee.id];
		}

		excluded = new AccessCheckExcludedRolePermissions(props.table, currentUserAccesses).checkExcludedRolePermissions(row.role);
	}
	let className = "";
	if (excluded.length != 0) {
		className = "text-danger";
	}

	if (!row.role.description && !row.role.administrativeRights && excluded.length == 0) {
		return <span className={className}>{row.role.name}</span>;
	}
	return <Tooltip title={
		<React.Fragment>
			{excluded.length != 0 && <div className="tooltip-panel-error">
				<i className="material-icons">
					error
					</i>
				<div className="tooltip-panel-content">
					{excluded.map((m, i) => <div key={i} >
						<Typography>Użytkownik posiada rolę <strong>{m}</strong>, która nie powinna być nadawana z wybraną rolą.</Typography>
					</div>)}
				</div>
			</div>}
			<Typography color="inherit" style={{ whiteSpace: "pre-line" }}>{row.role.description}</Typography>
			{row.role.administrativeRights && <p>({t("control.relation.administrativeRole")})</p>}
		</React.Fragment>
	}>
		<span className={className}>{row.role.name}</span>
	</Tooltip>
}